import { FaqItem } from '../types';

export interface FaqCategory {
  category: string;
  items: FaqItem[];
}

export function groupFaqItems(items: FaqItem[]): FaqCategory[] {
  const map = new Map<string, FaqItem[]>();
  for (const item of items) {
    if (!map.has(item.category)) map.set(item.category, []);
    map.get(item.category)!.push(item);
  }
  return Array.from(map.entries()).map(([category, categoryItems]) => ({ category, items: categoryItems }));
}
